import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des activités d'une agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getLomacoImport = (id, token) => {
    const url = `api-v1/admin/agency/${id}/import/lomaco`;
    return getRequest(url, token)
}